import { render } from "./square-image.vue?vue&type=template&id=2d536e79"
import script from "./square-image.vue?vue&type=script&lang=js"
export * from "./square-image.vue?vue&type=script&lang=js"

import "./square-image.vue?vue&type=style&index=0&id=2d536e79&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__